export default __webpack_public_path__ + "static/431-50f49613cee068c82d03a5cc4a7f0ce5.gif";